import React, { useId } from 'react';

// Single brand logo — same petals + soft core + sparkle, used on every page,
// in the header, and in the footer. Pass `size` to scale.
// `useId()` namespaces gradient defs so multiple instances on the same page
// don't collide on duplicate `id` attributes.
export default function Logo({ size = 32 }: { size?: number }) {
  const raw = useId();
  const ns = raw.replace(/:/g, '');
  const idP = `lg-${ns}-p`;
  const idB = `lg-${ns}-b`;
  const idC = `lg-${ns}-c`;

  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <defs>
        <radialGradient id={idP} cx="50%" cy="32%" r="68%">
          <stop offset="0%"   stopColor="#FFB0DC" />
          <stop offset="100%" stopColor="#D030A0" stopOpacity="0.88" />
        </radialGradient>
        <radialGradient id={idB} cx="50%" cy="32%" r="68%">
          <stop offset="0%"   stopColor="#A8DCFF" />
          <stop offset="100%" stopColor="#4C70E0" stopOpacity="0.88" />
        </radialGradient>
        <radialGradient id={idC} cx="50%" cy="50%" r="55%">
          <stop offset="0%"   stopColor="#FFFFFF" />
          <stop offset="50%"  stopColor="#FFF4FC" stopOpacity="0.65" />
          <stop offset="100%" stopColor="#F0A0D8" stopOpacity="0" />
        </radialGradient>
      </defs>
      <ellipse cx="16" cy="7.5" rx="5.0" ry="6.2" fill={`url(#${idP})`} opacity="0.90" transform="rotate(0,16,16)" />
      <ellipse cx="16" cy="7.5" rx="5.0" ry="6.2" fill={`url(#${idP})`} opacity="0.90" transform="rotate(120,16,16)" />
      <ellipse cx="16" cy="7.5" rx="5.0" ry="6.2" fill={`url(#${idP})`} opacity="0.90" transform="rotate(240,16,16)" />
      <ellipse cx="16" cy="7.5" rx="5.0" ry="6.2" fill={`url(#${idB})`} opacity="0.88" transform="rotate(60,16,16)" />
      <ellipse cx="16" cy="7.5" rx="5.0" ry="6.2" fill={`url(#${idB})`} opacity="0.88" transform="rotate(180,16,16)" />
      <ellipse cx="16" cy="7.5" rx="5.0" ry="6.2" fill={`url(#${idB})`} opacity="0.88" transform="rotate(300,16,16)" />
      <circle cx="16" cy="16" r="7" fill={`url(#${idC})`} />
      <path d="M16 12.2L16.72 14.8L19.4 16L16.72 17.2L16 19.8L15.28 17.2L12.6 16L15.28 14.8Z" fill="white" opacity="0.97" />
    </svg>
  );
}
